export enum SchedulingSettingsSection {
  PLANNING_BOARD = "PLANNING_BOARD",
  GEOCODING_AND_TRAVEL_TIMES = "GEOCODING_AND_TRAVEL_TIMES",
  PLANNING_CONTROL = "PLANNING_CONTROL",
}

export function localiseSchedulingSettingsSection(
  vue: Vue,
  schedulingSettingsSection: SchedulingSettingsSection
) {
  const prefix = "settings.scheduling.section";

  switch (schedulingSettingsSection) {
    case SchedulingSettingsSection.PLANNING_BOARD:
      return vue.$t(`${prefix}.planningBoard`);
    case SchedulingSettingsSection.GEOCODING_AND_TRAVEL_TIMES:
      return vue.$t(`${prefix}.geocodingAndTravelTimes`);
    case SchedulingSettingsSection.PLANNING_CONTROL:
      return vue.$t(`${prefix}.planningControl`);
  }
}
